import { createAction } from '@reduxjs/toolkit';

import type { AddLanguagePayload } from '@polyai/stream/commands/handlers/languages/add-language/schema';
import type { DeleteLanguagePayload } from '@polyai/stream/commands/handlers/languages/delete-language/schema';
import type { UpdateDefaultLanguagePayload } from '@polyai/stream/commands/handlers/languages/update-default-language/schema';

import { LANGUAGES_SLICE_NAME } from './constants';

export const updateDefaultLanguage = createAction<UpdateDefaultLanguagePayload>(
  `${LANGUAGES_SLICE_NAME}/updateDefaultLanguage`,
);

export const addLanguage = createAction<AddLanguagePayload>(
  `${LANGUAGES_SLICE_NAME}/addLanguage`,
);

export const deleteLanguage = createAction<DeleteLanguagePayload>(
  `${LANGUAGES_SLICE_NAME}/deleteLanguage`,
);
